var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-pendent-count"},[_c('svg-loader',{attrs:{"src":"/static/images/icon-alert-white.svg"}}),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.warningMessage)+" : "+_vm._s(_vm.pendentWarningCount)+"\n  ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }